// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageHeader_heading__2QCwv","headingImage":"PageHeader_headingImage__3lVpO"};